import { render, staticRenderFns } from "./FatherView.vue?vue&type=template&id=43368eee&"
import script from "./FatherView.vue?vue&type=script&lang=js&"
export * from "./FatherView.vue?vue&type=script&lang=js&"
import style0 from "./FatherView.vue?vue&type=style&index=0&id=43368eee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VContainer,VDialog})
